import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

export const About = () => {
  const team = [
    {
      name: 'Luana Marques de Campos',
      role: 'Advogada',
      description:
        'Natural de Campo Grande - MS, Especialista em Direito e Processo Previdenciário. OAB/RJ n° 245.253',
      image: '/luana-marques.jpg',
    },
    {
      name: 'Yuri Godoy Melo',
      role: 'Advogado',
      description:
        'Natural do Rio de Janeiro-RJ, Especialista em Direito e Processo Previdenciário e Tributário. OAB/RJ n° 226.804',
      image: '/yuri-godoy.jpg',
    },
    {
      name: 'Mara Lucia Godoy Melo',
      role: 'Advogada',
      description:
        'Natural do Rio de Janeiro - RJ, especialista em Direito e Processo Previdenciário e do Trabalho, formada em Administração de Empresas pela Universidade Santa Úrsula. OAB/RJ n° 221.567',
      image: '/mara-lucia.jpg',
    },
    {
      name: 'Mario Jefferson Barros Aguiar Pavão',
      role: 'Advogado',
      description:
        'Natural do Rio de Janeiro - RJ, especialista em Direito e Processo do Trabalho. OAB/RJ n° 228.189',
      image: '/mario-jefferson.jpg',
    },
  ];

  const values = [
    {
      icon: 'fa-bullseye',
      title: 'Missão',
      description:
        'Garantir justiça e segurança para nossos clientes, proporcionando atendimento singular e atentando-se às particularidades de cada caso.',
    },
    {
      icon: 'fa-eye',
      title: 'Visão',
      description:
        'Ser referência como empresa previdenciária administrativa, reconhecida pela excelência em direito previdenciário no país.',
    },
    {
      icon: 'fa-heart',
      title: 'Valores',
      description:
        'Eficácia e transparência com compromisso e ética profissional em cada atendimento e caso.',
    },
  ];

  const achievements = [
    { value: '500+', label: 'Casos Resolvidos' },
    { value: '7+', label: 'Anos de Experiência' },
    { value: '98%', label: 'Taxa de Aprovação' },
    { value: '3', label: 'Áreas de Atuação' },
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section
        className="relative min-h-[400px] flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage:
            'linear-gradient(135deg, rgba(45, 66, 56, 0.9) 0%, rgba(45, 66, 56, 0.8) 100%), url(https://images.unsplash.com/photo-1521737711867-e3b97375f902?q=80&w=2070)',
        }}
      >
        <div className="container-padding mx-auto text-center relative z-10">
          <div className="max-w-3xl mx-auto space-y-4 slide-up">
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-primary-foreground">
              Sobre Nós
            </h1>
            <p className="text-lg sm:text-xl text-primary-foreground/90">
              Compromisso e excelência na defesa dos seus direitos
            </p>
          </div>
        </div>
      </section>

      {/* Our Story Section */}
      <section className="section-padding bg-background">
        <div className="container-padding mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <div className="space-y-6 slide-in-left">
              <h2 className="font-display text-3xl sm:text-4xl font-bold text-primary">
                Nosso Propósito
              </h2>
              <p className="text-lg text-muted-foreground leading-relaxed">
                A Godoy & Aguiar é uma Sociedade de Advogados dedicada a orientar você em questões de Previdência, assistência, Direito do Trabalho e Tributário.
              </p>
              <p className="text-lg text-muted-foreground leading-relaxed">
                Nossa equipe atua de forma próxima e personalizada, sempre buscando a melhor posição possível dentro da lei, para que você tenha mais segurança e tranquilidade no seu dia a dia e no futuro.
              </p>
              <p className="text-lg text-muted-foreground leading-relaxed">
                Com mais de 7 anos de atuação, nossa equipe de advogados especializados já resolveu mais de 500 casos, sempre com transparência, compromisso e dedicação.
              </p>
            </div>

            <div className="relative slide-in-right">
              <img
                src="https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=2069"
                alt="Escritório de advocacia"
                className="rounded-lg shadow-2xl w-full h-auto"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Mission, Vision, Values */}
      <section className="section-padding bg-secondary">
        <div className="container-padding mx-auto">
          <div className="text-center max-w-3xl mx-auto mb-12 lg:mb-16 slide-up">
            <h2 className="font-display text-3xl sm:text-4xl font-bold text-primary mb-4">
              Nossos Pilares
            </h2>
            <p className="text-lg text-muted-foreground">
              Os valores que nos guiam em cada caso e em cada atendimento
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
            {values.map((value, index) => (
              <Card
                key={index}
                className="card-hover border-border text-center"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <CardContent className="p-8 space-y-4">
                  <div className="w-16 h-16 bg-accent-light rounded-full flex items-center justify-center mx-auto">
                    <i className={`fas ${value.icon} text-3xl text-accent`}></i>
                  </div>
                  <h3 className="font-display text-2xl font-semibold text-foreground">
                    {value.title}
                  </h3>
                  <p className="text-muted-foreground leading-relaxed">{value.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="section-padding bg-background">
        <div className="container-padding mx-auto">
          <div className="text-center max-w-3xl mx-auto mb-12 lg:mb-16 slide-up">
            <h2 className="font-display text-3xl sm:text-4xl font-bold text-primary mb-4">
              Nossa Equipe
            </h2>
            <p className="text-lg text-muted-foreground">
              Profissionais experientes e comprometidos com seus direitos
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
            {team.map((member, index) => (
              <Card
                key={index}
                className="card-hover border-border overflow-hidden"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="relative bg-muted overflow-hidden">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-auto object-contain transition-transform duration-500 hover:scale-105"
                  />
                </div>
                <CardContent className="p-6 space-y-3">
                  <h3 className="font-display text-2xl font-semibold text-foreground">
                    {member.name}
                  </h3>
                  <p className="text-accent font-semibold">{member.role}</p>
                  <p className="text-muted-foreground leading-relaxed">{member.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Achievements Section */}
      <section className="section-padding bg-primary text-primary-foreground">
        <div className="container-padding mx-auto">
          <div className="text-center mb-12 slide-up">
            <h2 className="font-display text-3xl sm:text-4xl font-bold mb-4">
              Nossas Conquistas
            </h2>
            <p className="text-lg text-primary-foreground/90">
              Números que refletem nosso compromisso e dedicação
            </p>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            {achievements.map((achievement, index) => (
              <div
                key={index}
                className="text-center slide-up"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="font-display text-4xl lg:text-5xl font-bold text-accent mb-2">
                  {achievement.value}
                </div>
                <div className="text-primary-foreground/80 font-medium">{achievement.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-padding bg-gradient-to-r from-accent to-accent-hover text-accent-foreground">
        <div className="container-padding mx-auto">
          <div className="max-w-4xl mx-auto text-center space-y-6 slide-up">
            <h2 className="font-display text-3xl sm:text-4xl font-bold">
              Entre em Contato Conosco
            </h2>
            <p className="text-lg">
              Clique no botão abaixo para iniciar uma conversa e nossa equipe entrará em contato.
            </p>
            <Button
              asChild
              size="lg"
              variant="outline"
              className="border-2 border-accent-foreground/20 text-accent-foreground hover:bg-accent-foreground/10 backdrop-blur-sm font-semibold px-8"
            >
              <Link to="/contato">
                <i className="fas fa-comments mr-2"></i>
                Fale Conosco
              </Link>
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;